export class CartItem {
	item_quantity: number; // Number of people - format integer ->> Example : 2
	item_PrestIds: string[]; // prestId selected - format string ->> Example : ??
	item_PrestNames: string[]; // prestName selected - format string - format string ->> Example : 3 pièces 4/6 personnes
	item_price_ati: string; // Item price all taxes included - format string
	item_begin_date: string; // Same value but could be updated on the product page - format string ->> Example : "28/06/2023"
	item_end_date: string; // Same value but could be updated on the product page - format string ->> Example : "14/07/2023"
	item_duration: string; // Same value but could be updated on the product page - format string ->> Example : "6 days"
	constructor(
		item_quantity: number,
		item_PrestIds: string[],
		item_PrestNames: string[],
		item_price_ati: string,
		item_begin_date: string,
		item_end_date: string,
		item_duration: string
	) {
		this.item_quantity = item_quantity;
		this.item_PrestIds = item_PrestIds;
		this.item_PrestNames = item_PrestNames;
		this.item_price_ati = item_price_ati;
		this.item_begin_date = item_begin_date;
		this.item_end_date = item_end_date;
		this.item_duration = item_duration;
	}
}
